import React from 'react';

import CMSContent from '../CMSContent/index.jsx';


/**
 * A convenience component to automatically wrap article excerpts in paragraph
 * tags where they are not already.
 * When WP generates an excerpt, it will normally return only the text (no
 * tags), so here we automatically wrap the excerpt in paragraph tags if they
 * have not already been wrapped in something.
 */
class ArticleExcerpt extends React.Component {
  render() {
    var excerpt = this.props.excerpt;

    if (excerpt && (! excerpt.startsWith('<'))) {
      excerpt = '<p>' + excerpt + '</p>';
    }


    return (
      <CMSContent content={excerpt} />
    );
  }
}

export default ArticleExcerpt;

